import { showErrorMessage } from "../components/presentation/common/snackbar";
import { ChatAPI } from "../config";
import { errorMessage } from "../utils/responseMessage";

export const callGetChatUsers =
  ({ name, pageNo, userType, use_pagination = false }) =>
  (dispatch) => {
    dispatch({
      type: "GET_CHAT_USERS_REQ",
    });
    ChatAPI.get(
      `/users?name=${name}&use_pagination=${use_pagination}&user_type=${userType}`
    )
      .then((response) => {
        if (response?.data?.status) {
          dispatch({
            type: "GET_CHAT_USERS_SUC",
            payload: response?.data,
          });
        } else {
        }
      })
      .catch(function (error) {
        showErrorMessage(errorMessage(error));
        dispatch({
          type: "GET_CHAT_USERS_FAIL",
        });
      });
  };

export const getChatConversation =
  ({ pageNo = 1, userType = "", name = "", use_pagination = false }) =>
  (dispatch) => {
    dispatch({
      type: "GET_CHAT_CONVERSATION_REQ",
    });
    ChatAPI.get(
      `/conversations/?use_pagination=${use_pagination}&user_type=${userType}&name=${name}`
    )
      .then((response) => {
        if (response?.data?.status) {
          dispatch({
            type: "GET_CHAT_CONVERSATION_SUC",
            payload: response?.data?.data,
          });
        } else {
        }
      })
      .catch(function (error) {
        showErrorMessage(errorMessage(error));
        dispatch({
          type: "GET_CHAT_CONVERSATION_FAIL",
        });
      });
  };

export const getForwardChatConversation =
  ({ pageNo, userType, name = "" }) =>
  (dispatch) => {
    dispatch({
      type: "GET_FORWARD_CHAT_CONVERSATION_REQ",
    });
    ChatAPI.get(
      `/conversations/?page=${pageNo}&user_type=${userType}&name=${name}`
    )
      .then((response) => {
        if (response?.data?.status) {
          dispatch({
            type: "GET_FORWARD_CHAT_CONVERSATION_SUC",
            payload: response?.data?.data,
          });
        } else {
        }
      })
      .catch(function (error) {
        showErrorMessage(errorMessage(error));
        dispatch({
          type: "GET_FORWARD_CHAT_CONVERSATION_FAIL",
        });
      });
  };

export const getConversationsByID =
  ({ id }) =>
  (dispatch) => {
    dispatch({
      type: "GET_CHAT_CONVERSATIONBYID_REQ",
    });
    ChatAPI.get(`/conversations/${id}`)
      .then((response) => {
        if (response?.data?.status) {
          dispatch({
            type: "GET_CHAT_CONVERSATIONBYID_SUC",
            payload: response.data,
          });
        } else {
        }
      })
      .catch(function (error) {
        showErrorMessage(errorMessage(error));
        dispatch({
          type: "GET_CHAT_CONVERSATIONBYID_FAIL",
        });
      });
  };

export const sendChatRequest =
  ({ payload }) =>
  (dispatch) => {
    dispatch({
      type: "SEND_CHAT_REQUEST_REQ",
    });
    ChatAPI.post(`/chat-request/`, payload)
      .then((res) => {
        if (res?.data) {
          dispatch({
            type: "SEND_CHAT_REQUEST_SUC",
            payload: res?.data?.data,
          });
          dispatch(getChatRequest());
        }
      })
      .catch((error) => {
        showErrorMessage(errorMessage(error));
        dispatch({
          type: "SEND_CHAT_REQUEST_FAIL",
        });
      });
  };

export const getChatRequest =
  (pageNo = 1) =>
  (dispatch) => {
    dispatch({
      type: "GET_CHAT_REQUEST_REQ",
    });
    ChatAPI.get(`/chat-request/?use_pagination=false`)
      .then((response) => {
        if (response?.data?.status) {
          dispatch({
            type: "GET_CHAT_REQUEST_SUC",
            payload: response?.data,
          });
        } else {
        }
      })
      .catch(function (error) {
        dispatch({
          type: "GET_CHAT_REQUEST_FAIL",
        });
      });
  };

export const sendChatRequestAction =
  ({ id, payload }) =>
  (dispatch) => {
    dispatch({
      type: "CHAT_REQUEST_ACTION_REQ",
    });
    ChatAPI.post(`/chat-request/${id}/action/`, payload)
      .then((res) => {
        if (res?.data) {
          dispatch({
            type: "CHAT_REQUEST_ACTION_SUC",
            payload: res?.data?.data,
          });
          dispatch(getChatConversation({ pageNo: 1 }));
          dispatch(getChatRequest());
        }
      })
      .catch((error) => {
        showErrorMessage(errorMessage(error));
        dispatch({
          type: "CHAT_REQUEST_ACTION_FAIL",
        });
      });
  };

export const getChatMessages =
  ({ conv_id, page, use_pagination }) =>
  (dispatch) => {
    dispatch({
      type: "GET_CHAT_MESSAGES_REQ",
    });
    ChatAPI.get(
      `/messages?conv_id=${conv_id}&page=${page}&use_pagination=${use_pagination}`
    )
      .then((response) => {
        if (response?.data?.status) {
          dispatch({
            type: "GET_CHAT_MESSAGES_SUC",
            payload: response.data,
          });
        } else {
        }
      })
      .catch(function (error) {
        showErrorMessage(errorMessage(error));
        dispatch({
          type: "GET_CHAT_MESSAGES_FAIL",
        });
      });
  };
